import { loadFirstFewRowsEstimates } from "components/jiffy/products/product-composition-estimates";

// Ensure DOM is ready (defer should handle this, but being defensive)
const initializeEstimates = () => {
  loadFirstFewRowsEstimates();
};

// If DOM is already loaded (defer guarantees this), run immediately
// Otherwise wait for DOMContentLoaded
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initializeEstimates);
} else {
  initializeEstimates();
}
